import { PARTNER_NAME, PARTNER_TYPE } from "../../../shared/types";
import { envPrefix } from "../../utils/envPrefix";
export const Configuration = {
    id: "iwt",
    brand: "immowelt",
    brandName: "Immowelt",
    portal: "immowelt.de",
    locale: "de",
    CP47Locale: "de-DE",
    searchCountries: ["DE"],
    priceLink: {
        comparison: true,
        plot: true,
        rent: true,
    },
    legal: {
        link1: {
            href: "https://www.aviv-group.com/companies",
            type: "link",
        },
        link2: {
            href: "https://www.immowelt.de/immoweltag/datenschutz",
            type: "link",
        },
        link3: {
            href: "https://www.immowelt.de/immoweltag/agb/immoweltagb",
            type: "link",
        },
    },
    urls: {
        oauth: `https://${envPrefix("-")}signin.immowelt.de`,
        assets: `https://www.${envPrefix(".")}immowelt.de/shared`,
        staging: {
            local: "http://localhost:3000",
            dev: "https://dev.immowelt.de",
            preview: "https://preview.immowelt.de",
            live: "https://www.immowelt.de",
        },
        seekerReport: `https://front-immowelt.peruvian-penguin-${process.env.CONFIG_ENV}.aws.aviv.eu/report`,
        autocompleteApiUrl: `https://autocomplete-api.cosmic-bullfrog-${process.env.CONFIG_ENV}.aws.aviv.eu/v1/autocomplete`,
        routingApiUrl: `https://private-routing-api-v1.cosmic-bullfrog-${process.env.CONFIG_ENV}.aws.aviv-internal.eu/route`,
        crsBaseUrls: {
            local: "https://dev.immowelt.de/contact-request-service",
            dev: "https://dev.immowelt.de/contact-request-service",
            preview: "https://preview.immowelt.de/contact-request-service",
            live: "https://www.immowelt.de/contact-request-service",
        },
        qualtricsSurvey: "https://avivgroup.qualtrics.com/jfe/form/SV_8jBQxektBdshUy2?Q_lang=DE",
    },
    urlPatterns: [
        // IWT Live pattern
        "/expose/:classifiedId",
        // Aviv preview URL
        "/cdp-preview/:classifiedId",
        // Aviv technical URL patterns
        "/wl-cdp/:classifiedId",
        // PDP pattern
        "/projekte/expose/:classifiedId",
    ],
    ads: {
        provider: "google",
        gptUrl: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
        optimizationScriptUrl: "https://cdn-a.yieldlove.com/v2/yieldlove.js?immowelt.de",
    },
    tracking: {
        site: "IWT",
        customerActions: { enabled: true },
        harvest: false,
        gtmLegacyUrl: "https://www.googletagmanager.com/gtm.js?id=GTM-PVVJVR5&l=dataLayer",
    },
    featuresEnabled: {
        georisk: false,
        favorites: true,
        priceComparisonRent: false,
        phoneNumberRequired: false,
        authentication: true,
        disableRobots: false,
        messageRequired: true,
        savedSearchOptIn: false,
        callTracking: false,
        partnerSubscriptionOptIn: false,
        plato: false,
        seekerProfileForRentalOnly: false,
        hideSalutationField: false,
        extendedContactForm: true,
        fetchLeadValue: false,
        triggerRequestCallbackModal: false,
        navigationBarTabs: false,
        navigationBarTags: false,
        suggestPrice: false,
        appleItuneApp: false,
        BICLayout: false,
    },
    partnerService: [
        {
            type: PARTNER_TYPE.priceLink,
            name: PARTNER_NAME.SCHUFA,
            url: `https://${envPrefix(".")}immowelt.de/schufa-bonitaetscheck?m=classified_detail_contextual_entry_landing_schufa`,
            text: "",
            validDistributionKeys: [],
            withLogo: false,
            pageViewGA4: {
                av_advertising: "partner_box",
                av_medium: "classified_detail_contextual_entry_landing_schufa",
                av_pagetitle: "landing_schufa",
                av_category: "other",
                av_site: "IWT",
                av_platform: "web",
                av_environment: process.env.CONFIG_ENV || "",
                av_language: "de",
            },
        },
        {
            type: PARTNER_TYPE.priceModal,
            name: PARTNER_NAME.KFW,
            withLogo: false,
            url: `https://${envPrefix(".")}immowelt.de/customer/kfw?m=classified_detail_contextual_entry_landing_kfw`,
            text: "advertising.slot.kfw.text",
            validDistributionKeys: ["SELL", "BUY", "AUCTION"],
            pageViewGA4: {
                av_advertising: "partner_box",
                av_medium: "classified_detail_contextual_entry_landing_kfw",
                av_pagetitle: "landing_kfw",
                av_category: "other",
                av_site: "IWT",
                av_platform: "web",
                av_environment: process.env.CONFIG_ENV || "",
                av_language: "de",
            },
        },
    ],
    kameleoon: {
        siteCode: "lrj80dsya2",
        env: process.env.CONFIG_ENV,
    },
    lokaliseSpecificKeys: {
        contactFormSubmitPrivate: "contact.form.submit_button",
        contactFormSubmitAgency: "contact.form.submit_button",
        emailButtonPrivate: "contact.card.email",
        emailButtonAgency: "contact.card.email",
        contactModalTitlePrivate: "contact.modal.title",
        contactModalTitleAgency: "contact.modal.title",
    },
};
